var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"gfs:icon1/arrow-left","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M14.965 7.066a1.938 1.938 0 0 0 0-2.74h-.14l-7.499 7.498v.142l7.498 7.501h.142a1.935 1.935 0 0 0 0-2.737L10.134 11.9l4.83-4.833z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }